<nav class="landing-col-1 bmt-navigation">
  <ul class="icon-list">
    @if (navFeatures().includes('hasProducerToolkitAccess')) {
    <li class="icon-list-item">
      <a target="_blank" [href]="producerToolkitUrl">
        <span class="icon icon-network"></span>
        <p class="icon-text">Go to Producer Toolkit</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('manageeligibility')) {
    <li class="icon-list-item">
      <a routerLink="/eligibility/member" [ngClass]="{'left-nav-active': eligActive()}">
        <span class="icon icon-family-enrollment"></span>
        <p class="icon-text" [ngClass]="{'left-nav-active': eligActive()}">Manage Eligibility</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('lad')) {
    <li class="icon-list-item">
      <a target="_blank" href="https://url.us.m.mimecastprotect.com/s/a_vuCM829OCqJRg1twfBC8fFfa?domain=matrixabsence.com*__;Lw!!MfglImS6eqc5!FneE2n98yvB6KY6hKpplgiul44Wk2CYHcaZXtIJbYBUBYdfEez_fjSP53YDcTg1hcYBczfTGSJVaT0NjUati7YutZHw8evJV$" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-lad"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Reliance Matrix</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('benefitsInquiry')) {
    <li class="icon-list-item">
      <a routerLink="/benefits" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-search"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Benefits Inquiry</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('sat')) {
    <li class="icon-list-item">
      <a routerLink="/sat" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-search"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">SAT</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('reports')) {
    <li class="icon-list-item">
      <a routerLink="/reports" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-report"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Reports</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('clientknowledge')) {
    <li class="icon-list-item">
      <a routerLink="/clientknowledge" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-client-knowledge-reports"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Client Knowledge Reports</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('dentistDirectory') && !renPlan) {
    <li class="icon-list-item">
      <a routerLink="/dentist" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-dentist"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Dentist Directory</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('summaryOfChanges')) {
    <li class="icon-list-item">
      <a routerLink="summary-of-changes" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-summary-changes"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Summary of Changes</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('billing')) {
    <li class="icon-list-item">
      <a routerLink="/billing" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-billing"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Billing</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('userAdmin')) {
    <li class="icon-list-item">
      <a routerLink="/userAdmin/create" [ngClass]="{'left-nav-active': userAdminActive()}">
        <span class="icon icon-group-admin"></span>
        <p class="icon-text" [ngClass]="{'left-nav-active': userAdminActive()}">User Admin</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('profile')) {
    <li class="icon-list-item">
      <a routerLink="/profile/authorizations" [ngClass]="{'left-nav-active': profileActive()}">
        <span class="icon icon-user-profile"></span>
        <p class="icon-text" [ngClass]="{'left-nav-active': profileActive()}">Profile</p>
      </a>
    </li>
    }
    @if (navFeatures().includes('profile')) {
    <li class="icon-list-item">
      <a routerLink="/help" [routerLinkActive]="['left-nav-active']">
        <span class="icon icon-help"></span>
        <p class="icon-text" [routerLinkActive]="['left-nav-active']">Help</p>
      </a>
    </li>
    }
  </ul>
</nav>
